// extracted by mini-css-extract-plugin
export default {"main":"about_main__jHipE"};